module.exports = __WEBPACK_EXTERNAL_MODULE__cognite_cdf_sdk_singleton__;